"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperatorFacingError = void 0;
exports.operatorMessage = operatorMessage;
/**
 * An error whose message was written for the operator: show it as-is.
 *
 * Generic error sites use `operatorMessage` instead of special-casing each
 * venue's error classes, so a venue can explain a state ("Open the Novig app…")
 * without the UI knowing about it.
 */
class OperatorFacingError extends Error {
}
exports.OperatorFacingError = OperatorFacingError;
function operatorMessage(error, fallback) {
    return error instanceof OperatorFacingError ? error.message : fallback;
}
